import React from 'react'
import PropTypes from 'prop-types'
import { Card, Radio } from 'antd-mobile'
import { YenSpan } from '../common/YenSpan'

// const imgSrc = 'https://img.alicdn.com/imgextra/i2/1689375269/O1CN01U2cfi81onFM8U5Ur6_!!1689375269.jpg_640x640q85s150_.webp'

class ShoppingCartItem extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string,
    checked: PropTypes.bool,
    imgSrc: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onItemClick: PropTypes.func,
    onItemChecked: PropTypes.func,
    onAmountChange: PropTypes.func,
    onItemDelete: PropTypes.func
  }

  render () {
    const {
      title, price, checked, amount, imgSrc
    } = this.props
    return <Card className={'m-2'}>
      <div className={'flex justify-between'}>
        <Radio className={'mr-3'}  checked={checked} readOnly
               onClick={this.onChecked}/>
        <div className={'flex flex-auto'}>
          <img className={'h-auto w-24'} src={imgSrc} alt="" onClick={this.onClick}/>
          <div className={'flex-auto ml-4'}>
            <div className={'line-clamp-2 mb-4'} onClick={this.onClick}>{title}</div>
            <div className={'flex justify-between'}>
              <YenSpan className={'text-red-500'}>{price}</YenSpan>
              <div>
                <i className={'icon-font icon-minus'} onClick={this.onAmountMinus}/>
                &emsp;{amount}&emsp;
                <i className={'icon-font icon-add'} onClick={this.onAmountPlus}/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={'text-right text-sm text-gray-500'}>
        <span onClick={this.onDelete}>删除</span>
      </div>
    </Card>
  }

  onClick = () => {
    const { id, onItemClick } = this.props
    onItemClick && onItemClick(id)
  }

  onChecked = () => {
    const { onItemChecked, id, index, checked, amount } = this.props
    onItemChecked && onItemChecked({ id, index, amount, checked: !checked })
  }

  onDelete = () => {
    const { onItemDelete, index } = this.props
    onItemDelete && onItemDelete(index)
  }

  onAmountPlus = () => {
    const { amount, id, index, checked, onAmountChange } = this.props
    onAmountChange && onAmountChange({ id, index, checked, amount: Number(amount) + 1 })
  }

  onAmountMinus = () => {
    const { amount, id, index, checked, onAmountChange } = this.props
    if (amount > 1) {
      onAmountChange && onAmountChange({ id, index, checked, amount: Number(amount) - 1 })
    }
  }
}

class AgreementDeliveryItem extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string,
    checked: PropTypes.bool,
    imgSrc: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onItemClick: PropTypes.func,
    onItemChecked: PropTypes.func,
  }

  render () {
    const {
      title, price, checked, amount, imgSrc
    } = this.props
    return <Card className={'m-2'}>
      <div className={'flex justify-between'}>
        <Radio className={'mr-3'}  checked={checked} readOnly
               onClick={this.onChecked}/>
        <div className={'flex flex-auto'}>
          <img className={'h-auto w-24'} src={imgSrc} alt="" onClick={this.onClick}/>
          <div className={'flex-auto ml-4'}>
            <div className={'line-clamp-2 mb-4'} onClick={this.onClick}>{title}</div>
            <div className={'flex justify-between'}>
              <YenSpan className={'item-card__price item-card__price--red'}>{price}</YenSpan>
              <div>{amount}</div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  }

  onClick = () => {
    const { id, onItemClick } = this.props
    onItemClick && onItemClick(id)
  }

  onChecked = () => {
    const { onItemChecked, id, index, checked, amount } = this.props
    onItemChecked && onItemChecked({ id, index, amount, checked: !checked })
  }

}

export { ShoppingCartItem, AgreementDeliveryItem }
